import React, {useRef} from 'react';

import {MediaQuery} from '@optimaxdev/design-system';
import {Icon, ArrowLeft, ArrowRight} from '@optimaxdev/icons';
import classNames from 'classnames';
import {useMediaQuery} from 'react-responsive';
import {Navigation} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';

import {createOnSwiper} from 'libs/swiper/createOnSwiper';

import {AccessoryType, AccessoryWindowType} from '../../store/reducers/accessories/accessoriesType';

import {NewCartAccessoryItemConnected} from '../newCartAccessoryItem/newCartAccessoryItem';
import {TrueViewForAccessories} from '../trueViewForAccessories/trueViewForAccessories';

import s from './newCartAccessoriesList.scss';

export type PropsType = {
    accessories: Array<AccessoryWindowType>;
};

const getSpaceBetween = (sm: boolean, md: boolean) => {
    if (sm) return 16;
    else if (md) return 21;
    return 20;
};

/**
 * List of accessories on cart page
 * @param {PropsType} props accessory images props
 * @returns {Node} accessory media component
 */
export const NewCartAccessoriesList = ({accessories}: PropsType) => {
    const md = useMediaQuery(MediaQuery.md);
    const sm = useMediaQuery(MediaQuery.sm);
    const navigationNextRef = useRef(null);
    const navigationPrevRef = useRef(null);

    const renderItems = (
        onViewAccessory: (accessory: AccessoryType, isLastElement: boolean) => void,
        isSwiper?: boolean,
    ) =>
        accessories.map((accessory, index) => {
            if (isSwiper)
                return (
                    <SwiperSlide key={accessory.sku || index} tag="li">
                        <NewCartAccessoryItemConnected
                            isLastElement={accessories.length === index + 1}
                            key={accessory.id}
                            onViewAccessory={onViewAccessory}
                            windowAccessoryId={accessory.id}
                        />
                    </SwiperSlide>
                );
            return (
                <NewCartAccessoryItemConnected
                    isLastElement={accessories.length === index + 1}
                    key={accessory.id}
                    onViewAccessory={onViewAccessory}
                    windowAccessoryId={accessory.id}
                />
            );
        });

    if (accessories.length < 4)
        return (
            <div className={s.list}>
                <TrueViewForAccessories displayedAccessories={accessories}>
                    {({onViewAccessory}) => <>{renderItems(onViewAccessory, false)}</>}
                </TrueViewForAccessories>
            </div>
        );

    return (
        <TrueViewForAccessories displayedAccessories={accessories}>
            {({onViewAccessory}) => (
                <div className={classNames(s.container)}>
                    <button
                        aria-label="Next slide"
                        className={classNames(s.btn, s.next)}
                        ref={navigationNextRef}
                        type="button"
                    >
                        <Icon className={classNames(s.arrow)} icon={ArrowRight} strokeWidth={2} />
                    </button>
                    <button
                        aria-label="Previous slide"
                        className={classNames(s.btn, s.prev)}
                        ref={navigationPrevRef}
                        type="button"
                    >
                        <Icon className={classNames(s.arrow)} icon={ArrowLeft} strokeWidth={2} />
                    </button>
                    <Swiper
                        modules={[Navigation]}
                        onInit={createOnSwiper(navigationNextRef, navigationPrevRef)}
                        slidesPerGroup={3}
                        slidesPerView={3}
                        spaceBetween={getSpaceBetween(sm, md)}
                        speed={300}
                        tag="ul"
                    >
                        {renderItems(onViewAccessory, true)}
                    </Swiper>
                </div>
            )}
        </TrueViewForAccessories>
    );
};
